<template>
  <v-container class="v-container">
    
    <v-row no-gutters>
      
      <v-col cols="12" sm="6" style="padding:20px;">
          <v-row  no-gutters>
            <v-col cols="12" sm="6">
              {{ tutoriais?.length }} videos no total.
            </v-col>
            <v-col cols="12" sm="6" style="display:flex;justify-content: end;">
              {{ qtdeVideosRestantes }} videos restantes.
            </v-col>
          </v-row>
          <v-row no-gutters>
              <v-data-table
                :headers="headerstutorial"
                :items="tutoriais"
                items-per-row=5
                item-key="id"
              >
              <template v-slot:[`item.titulo`]="{ item }">
                <div style='margin:5px;'>
                  <h2 style="font-weight: 500;">{{ item.titulo }}</h2>
                  <div style="padding-left:20px;">
                    <span style="font-size:14px;font-weight: 100;white-space: pre-line;">{{ item.descricao }}</span>
                    <!-- <span style="font-size:14px;font-weight: 100;white-space: pre-line;">{{ item }}</span> -->
                  </div>
                </div>
              </template>

              <template v-slot:[`item.play`]="{ item }">
                  <v-btn :color="item.assistido?'error':'success'" @click="loadvideo(item)">{{item.assistido?'Assistido':'Play'}}</v-btn>
              </template>
                
              </v-data-table>
          </v-row>
      </v-col>

      <v-col cols="12" sm="6" style="padding-top:20px;">

        <div id="videoData">
              <h1 v-if="videoselecionado" >Video: {{ videoselecionado.titulo }}</h1>
              <h3 v-if="videoselecionado" style="color:#0170d0;">O vídeo só será considerado assistido se for visto por completo e sem interrupções.</h3>
              <br>
              <video v-if="videoCarregado" width="75%" style="max-width: 60em;" autoplay="" controls="" class="center-block" id="video" 
                  v-on:timeupdate="checaTamanhoVideoAssistido()" 
                  v-on:loadedmetadata="checaTamanhoTotalVideo()">
                  <source v-if="videoCarregado" type="video/mp4" :src="videoCarregado" />
              </video>
        </div>  
        <v-row no-gutters>
          <v-col cols="12" sm="4"><p style="font-weight:200;">Segundos Assitidos: {{ totalPlayed }}s</p></v-col>
          <v-col cols="12" sm="4"><p style="font-weight:200;">Tamanho do video em Segundos:{{ totalTimeVideo }}s</p></v-col>
          <v-col cols="12" sm="4"></v-col>
        </v-row>
      </v-col>
    </v-row>
   
  </v-container>
</template>

<script>
import axios from 'axios'

import { tokenapies } from '@/constantes.js'

import {BUILD_APIES_URL,BUILD_ID_CLIENTE} from '@/constantes.js'


export default {
    data: () => ({
        marcou: false,
        qtdeVideoAssistidos:0,
        qtdeVideosRestantes:0,
        snack: false,
        videoCarregado:'',
        totalTimeVideo:0,
        totalPlayed: 0,
        currentTimeVideo: 0,
        videoselecionado: null,
        snackColor: "",
        snackText: "",
        search: "",
        tutoriais: [],
        headerstutorial:[
          {text:'Tutorial',value:'titulo'},
          {text:'Play',value:'play'}
        ],
        itemstutorial:[
          {titulo:'video1',url:'dsada',id:1,action:'.'}
        ],
        headers: [
            { text: "Sistema", value: "sistema" },
            { text: "Título", value: "titulo" },
            { text: "Descrição", value: "descricao" },
            { text: "Id do Video", value: "video" },
        ],
    }),
    computed: {},
    watch: {},
    methods: {
        
        loadvideo(item){
          this.marcou = false
          console.log('item',item);
          this.videoselecionado = item
          this.videoCarregado = null
          console.log('loadvideo',item);
          let videosplited = item.video.split('videostutoriais')[1];
          let prefixo = 'https://esvideos.economysoftware.com.br/videos/tutoriais'
          console.log('videosplited',videosplited);
          console.log('prefixo',prefixo);
          this.videoCarregado = prefixo+videosplited
          console.log('this.videoCarregado',this.videoCarregado)

          // setTimeout(() => {
          //   this.maximizarVideo()
          // }, 2000);

          document.getElementById("video").load()


          
          
        },
        abrirTutorial(item) {
            this.$router.push("/dashboard/tutorial/" + item.id);
        },
        carregarTutoriais() {
            this.qtdeVideoAssistidos = 0
            let baseURL = BUILD_APIES_URL;
            axios.post(baseURL + "/tutorial/select", { idioma: "pt-BR",ativo:true, sistema: 1, "uid": localStorage.getItem("userid"),idcliente:BUILD_ID_CLIENTE }, { headers: { "x-access-token": tokenapies } })
                .then((response) => {
                if (response.status == 200) {
                    this.tutoriais = response.data;
                    for(let i=0;i<this.tutoriais.length;i++){
                        if(this.tutoriais[i].assistido){
                            this.qtdeVideoAssistidos++
                        }
                    }

                    this.qtdeVideosRestantes = this.tutoriais.length - this.qtdeVideoAssistidos
                }
            })
                .catch((error) => {
                console.log(error);
            });

        },
        checaTamanhoVideoAssistido() {

          if(this.videoCarregado){
              var video = document.querySelector('video');
              if (video) {
                  var currentTime = video.currentTime;
                  this.currentTimeVideo = currentTime;
                  var totalPlayed = 0;
                  var played = video.played;
                  for (var i = 0; i < played.length; i++) {
                      totalPlayed += played.end(i) - played.start(i);
                  }
                  this.totalPlayed = Math.floor(totalPlayed);
                  if(this.totalPlayed > (this.totalTimeVideo * 0.9) && this.marcou == false ){
                      this.marcou = true
                      let baseURL = BUILD_APIES_URL;
                      axios.post(baseURL + "/tutorial/marcarassistido", { idioma: "pt-BR",ativo:true,idtutorial:this.videoselecionado.id, sistema: 1, "uid": localStorage.getItem("userid"),idcliente:BUILD_ID_CLIENTE }, { headers: { "x-access-token": tokenapies } })
                          .then((response) => {
                          if (response.status == 200) {
                              this.videoselecionado.assistido = true
                              this.carregarTutoriais()
                          }
                      })
                  }
              }
          }
        },
        checaTamanhoTotalVideo() {
          if(this.videoCarregado){
            let vid = document.getElementById("video");
            this.totalTimeVideo = Math.floor(vid.duration);
          }
        },
        maximizarVideo(){
          const video = document.getElementById('video');

          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitRequestFullscreen) { // Safari
            video.webkitRequestFullscreen();
          } else if (video.msRequestFullscreen) { // IE/Edge antigos
            video.msRequestFullscreen();
          }
        }
    },
    mounted() {
        this.carregarTutoriais();
    },
    components: { }
};
</script>

<style scoped>

.table-row {
  cursor: pointer;
}
.selected {
  background-color: rgb(154, 209, 253)!important;;
}
.table-row:hover {
  background-color: rgb(33, 150, 243)!important;
  color: white;
  font-weight: bold;
}
</style>